export class WbShareLink {
    constructor() { }

    init() {
        return new Promise((resolve, reject) => {
            this.bindListeners();
            resolve();
        });
    }

    bindListeners() {
        const _this = this;
        document.
            querySelector('body')
            ._addCustomEventListener(
                'click',
                '.share-link',
                _this.shareLink.bind(_this)
            );
    }

    shareLink(e) {
        e.preventDefault();
        const link = e.target;
        const url = link.getAttribute('href') || '#';

        if (navigator.share) {
          const title = link.getAttribute('title') || document.title;

          navigator.share({
            title,
            url,
          });
        } else {
            const encodedUrl = encodeURIComponent(url);
            const mailToLink = `mailto:?body=${encodedUrl}`;

            location.href = mailToLink;
        }
    }
}      